// @flow
import React from 'react';
import styled from 'styled-components';
/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.104.0. To view the error, delete this comment and run Flow. */
import type { ReactComponentStyled } from 'styled-components';
import { TabList, TabListProps } from '@reach/tabs';
import '@reach/tabs/styles.css';
import Theme from './theme';
import TypographyTheme from '../../typography/theme';
import type { DataProvidesProps } from '../../utils/constants';
import { getDataProvidesProps } from '../../utils/constants';

export const StyledTabList = (props: {
  ...TabListProps,
  ...DataProvidesProps,
}) => {
  const { children } = props;

  return (
    <StyledTabListWrapper {...getDataProvidesProps(props)}>
      {children}
    </StyledTabListWrapper>
  );
};

const StyledTabListWrapper: ReactComponentStyled<TabList> = styled(
  (props: TabListProps) => <TabList {...props} />
)`
  && {
    background: none;
    float: left;
    width: 12rem;
    padding-right: 1rem;
  }

  > [data-reach-tab] {
    border: none;
    padding: 0.5rem 0 0.5rem 1.5rem;
    margin-bottom: 1px;
    width: 100%;
    text-align: left;

    &:active {
      background: none;
    }

    &:hover {
      background: ${Theme.hover.backgroundColor};
    }

    &[data-selected] {
      background: ${Theme.selected.backgroundColor};
      color: ${TypographyTheme.colors.primary};
      border-radius: 0px 5px 5px 0px;
    }
  }
`;

TabList.defaultProps = { 'data-provides': 'tab-list' };
